import { Component, Input } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
    selector: 'app-res-squint-heatmap',
    templateUrl: './res-squint-heatmap.component.html',
    styleUrl: './res-squint-heatmap.component.scss',
    standalone: false
})
export class ResSquintHeatmapComponent {
  @Input() data: any[] = [];

  chartData: any[] = [];

	ready = false;
  legend = false;
	animations = false;
	xAxis = true;
	yAxis = true;
	showYAxisLabel = true;
	showXAxisLabel = true;
	min = 0;
	max = 3;
	colorScheme: string | Color = {
		name: 'myScheme',
		selectable: true,
		group: ScaleType.Ordinal,
		domain: ['transparent', '#15A607', '#F1D50A', '#F1960A', '#F11C0A'],
	};

  lastel = 0; // eyeSquintLeft
	laster = 0; // eyeSquintRight
	lastcl = 0; // cheekSquintLeft
	lastcr = 0; // cheekSquintRight
	
  showHeatmap() {
		this.ready = true;
		this.calculateHeatMapData(20);
	}

  calculateHeatMapData(currentTime: number) {
		const start = currentTime - 20;
		const dataChart = [];

		for (let index = start; index <= currentTime; index++) {
			const time = this.convertToTimerFormat(index);

			let el;
			let er;
			let cl;
			let cr;

			if (index < this.data.length) {
				el = this.data[index]['eyeSquintLeft_active'];
				er = this.data[index]['eyeSquintRight_active'];
				cl = this.data[index]['cheekSquintLeft_active'];
				cr = this.data[index]['cheekSquintRight_active'];

				this.lastel = el;
				this.laster = er;
				this.lastcl = cl;
				this.lastcr = cr;
			} else {
				el = this.lastel;
				er = this.laster;
				cl = this.lastcl;
				cr = this.lastcr;
			}

			let data = {};

			data = {
				name: time,
				series: [
					{ name: 'Left Eye Squint', value: el, original: el },
					{ name: 'Right Eye Squint', value: er, original: er },
					{ name: 'Left Cheek Squint', value: cl, original: cl },
					{ name: 'Right Cheek Squint', value: cr, original: cr }
				]
			};

			dataChart.push(data);
		}

		this.chartData = [...dataChart];

		if (!this.ready) {
			this.ready = true;
		}
	}

  tooltipText(data: any): string {
		const cell = JSON.parse(JSON.stringify(data)).cell;

		let spanContent;

		if (Array.isArray(cell.original)) {
			const listItems = cell.original.map((item: any) => `<li>${item}</li>`).join('');
			spanContent = `<ol>${listItems}</ol>`;
		} else {
			spanContent = cell.original;
		}

		const span = `<span>${spanContent}</span>`;

		const tool = `
			<div class="p-1 fs-16">
				${cell.series} - ${cell.name}
				<hr class="m-0">
				${span}
			</div>
		`;

		return tool;
	}

	updateHeatmap(currentTime: number) {
		if (currentTime > 20) {
			this.calculateHeatMapData(currentTime);
		} else {
			this.calculateHeatMapData(20);
		}
	}

	convertToTimerFormat(seconds: number) {
		if (seconds < 3600) {
			// Display "mm:ss" format for the first 60 minutes
			const minutes = Math.floor(seconds / 60);
			const formattedSeconds = (seconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			return `${formattedMinutes}:${formattedSeconds}`;
		} else {
			// After 60 minutes, switch to "hh:mm:ss" format
			const hours = Math.floor(seconds / 3600);
			const remainingSeconds = seconds % 3600;
			const minutes = Math.floor(remainingSeconds / 60);
			const formattedSeconds = (remainingSeconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			const formattedHours = hours.toString().padStart(2, "0");
			return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		}
	}
}
